// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { Dispatch } from '..';

// Types

export type DaysMap = {
  mapState: ('DAYS' | 'GROUPS') | null | undefined;
};
export type State = DaysMap;

type SetMapStateAction = {
  type: 'SET_MAP_STATE';
  mapState: ('DAYS' | 'GROUPS') | null | undefined;
};
export type Action = SetMapStateAction;

// Reducer

export default function daysMapReducer(
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: State = {
    mapState: null,
  },
  action: Action
) {
  switch (action.type) {
    case 'SET_MAP_STATE': {
      const { mapState } = action;
      return { ...state, mapState };
    }

    default:
      // this causes a flow error if there are any unhandled actions
      action as never;

      return state;
  }
}

// Actions

export const setMapState =
  (mapState: ('DAYS' | 'GROUPS') | null | undefined) => (dispatch: Dispatch) =>
    dispatch({
      type: 'SET_MAP_STATE',
      mapState,
    });
